export default "__VITE_ASSET__BSFE2MRY__"